import axios from 'axios'

const BASE_URL = process.env.REACT_APP_SERVER_URI

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Request-Site': 'Privacy policy Generator'
  },
  withCredentials: true
});

const instanceWithoutToken = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Request-Site': 'Privacy policy Generator'
  }
});


instance.interceptors.request.use(
  async (config) => {
    let token = ''
    try {
      const response = await instanceWithoutToken.post('api/privacy-policy/ui/token');
      token = response.data.access
    } catch (e) {
    }
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

export default instance
export {
  instanceWithoutToken
}
